import { ChevronRightIcon } from '@chakra-ui/icons';
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, Flex } from '@chakra-ui/react';
import Link from 'next/link';
import Image from 'next/image';
import Home from '@/img/icons/home.svg';
import { BreadcrumbType } from '@/Types/types';
import { configFile } from '@/config';

type Props = {
  data: BreadcrumbType[];
};

export default function Breadcrumbs({ data }: Props) {
  return (
    <Flex
      marginTop="80px"
      mb="24px"
      height="32px"
      position="relative"
      alignItems="center"
      _before={{
        content: '""',
        position: 'absolute',
        bottom: '0',
        top: '0',
        right: '-1',
        w: '50px',
      }}
      overflow="hidden"
      gap="16px"
    >
      <Image src={Home} alt="Home" />

      <Breadcrumb
        color={configFile.tertiaryAccentColor}
        fontWeight="normal"
        fontSize="sm"
        lineHeight="5"
        spacing="21px"
        separator={<ChevronRightIcon color="gray.500" />}
        overflow="scroll"
        __css={{
          '& ol': {
            display: 'block',
            width: 'max-content',
          },
          msOverflowStyle: 'none',
          scrollbarWidth: 'none',
          '&::-webkit-scrollbar': {
            display: 'none',
          },
        }}
      >
        {data?.length &&
          data.map((breadcrumb, index) => (
            <BreadcrumbItem
              color={index === data.length - 1 ? configFile.fiveAccentColor : ''}
              key={index}
              pr={index === data.length - 1 ? '40px' : '0'}
            >
              <BreadcrumbLink wordBreak="normal" as={Link} href={breadcrumb.href}>
                {breadcrumb.label}
              </BreadcrumbLink>
            </BreadcrumbItem>
          ))}
      </Breadcrumb>
    </Flex>
  );
}
